//Auto-generated, please do not edit.

export default
{
    "common": {
        "total-sessions": "TOPLAM OTURUMLAR",
        "new-sessions": "YENİ OTURUMLAR",
        "unique-sessions": "TEKİL OTURUMLAR",
        "total-users": "TOPLAM KULLANICILAR",
        "new-users": "YENİ KULLANICILAR",
        "returning-users": "YENİDEN GELENLER",
        "date": "Tarih",
        "percent": "Yüzde",
        "number-of-users": "Kullanıcı Sayısı",
        "number-of-sessions": "Oturum Sayısı",
        "table": {
            "no-data": "Veri yok",
            "total-users": "Toplam Kullanıcılar",
            "new-users": "Yeni Kullanıcılar",
            "returning-users": "Yeniden Gelen Kullanıcı",
            "total-sessions": "Toplam Oturumlar",
            "new-sessions": "Yeni Oturumlar",
            "unique-sessions": "Tekil Oturumlar"
        },
        "today": "Bugün",
        "7days": "7 gün",
        "30days": "30 gün",
        "60days": "60 gün",
        "90days": "90 gün",
        "from": "from",
        "to": "to",
        "compare-to": "Karşılaştır",
        "no-comparison": "Karşılaştırma yok",
        "comparison-desc": "Select comparison type to show past data on the same graph",
        "yesterday": "Dün",
        "previous-period": "Önceki periyod",
        "previous-year": "Önceki yıl içinde aynı periyod",
        "bar": {
            "top-resolution": "ÇÖZÜNÜRLÜKLER",
            "top-carrier": "OPERATÖRLER",
            "top-users": "KULLANICILAR",
            "top-platform": "PLATFORMLAR",
            "top-platform-version": "PLATFORM SÜRÜMLERİ",
            "top-devices": "CİHAZLAR",
            "no-data": "Veri Yok"
        },
        "apply": "Uygula",
        "apply-changes": "Değişiklikleri kaydet",
        "cancel": "İptal",
        "select": "Select",
        "select-all": "Tümünü seç",
        "deselect-all": "Seçimi kaldır",
        "all": "Tümü",
        "select-type": "Türü seç",
        "yes": "Evet",
        "no": "Hayır",
        "done": "Tamam",
        "save": "Kaydet",
        "saving": "Kaydediliyor",
        "close": "Kapat",
        "copy-id": "Widget ID'yi kopyala",
        "loading": "Yükleniyor",
        "continue": "Devam et",
        "okay": "Tamam",
        "add": "Ekle",
        "delete": "Sil",
        "edit": "Düzenle",
        "lock": "Kilitle",
        "locked": "Kilitli",
        "unlock": "Kilidi aç",
        "unlocked": "Kilitsiz",
        "ok": "Tamam",
        "total": "Toplam",
        "status": "Duru",
        "select-status": "Durumu seç",
        "type": "Tür",
        "time": "Zaman",
        "started": "Başlama",
        "info": "Bilgi",
        "save-changes": "Değişiklikleri kaydet",
        "graph-max": "En yüksek <b>{0}</b> {1} <b>{2}</b> tarihinde gerçekleşti",
        "graph-min": "En düşük <b>{0}</b> {1} <b>{2}</b> tarihinde gerçekleşti",
        "graph": {
            "time-spent": "Geçirilen Süre (dk)",
            "average-time": "Ort. Geçirilen Süre (min)",
            "reqs-received": "Alınan İstekler",
            "avg-reqs-received": "Ort. Alınan İstekler",
            "no-data": "Bu periyod için gösterilecek bir veri bulunmuyor"
        },
        "seconds": "saniye",
        "minutes": "dakika",
        "hour": "saat",
        "second": {
            "abrv": "s",
            "abrv2": "s"
        },
        "minute": {
            "abrv": "d",
            "abrv2": "d"
        },
        "day": {
            "abrv": "gün",
            "abrv2": "gün"
        },
        "year": {
            "abrv": "yıl",
            "abrv2": "y"
        },
        "buckets": {
            "monthly": "aylık",
            "weekly": "haftalık",
            "daily": "günlük",
            "months": "aylar",
            "weeks": "haftalar",
            "days": "günler"
        },
        "max": "Max",
        "create": "Oluştur",
        "session-expiration": "Oturum sonlanması",
        "click-to-login": "Giriş yapmaya devam etmek için tıklayın",
        "expire-minute": "Oturumunuz 1 dakika içinde sonlanacaktır",
        "expire-seconds": "Oturumunuz 10 saniye içinde sonlanacaktır",
        "add-new-app": "Yeni uygulama ekle",
        "add-new-app-button": "Yeni uygulama ekle",
        "change-app-type": "uygulama türünü değiştir",
        "install-plugin": "Lütfen eklenti kurun",
        "or": "ya da",
        "missing-type": "Sistem bu tür bir uygulamayı desteklemiyor:",
        "feedback-and-support": "Feedback & Support",
        "provide-feedback": "Provide Feedback",
        "support": "Destek",
        "documentation": "Dokümantasyon",
        "help-center": "Help Center",
        "feature-request": "Request a Feature",
        "showing": "Toplam _TOTAL_ satır içinden _START_ ve _END_ arası görüntüleniyor",
        "filtered": "(Toplam _MAX_ satır içinden filtrelenmiştir)",
        "enterprise-edition": "Enterprise Edition (destekli)",
        "save-to-csv": "CSV kaydet",
        "save-to-excel": "Excel kaydet",
        "search": "Ara",
        "unknown": "Bilinmeyen",
        "eu": "Avrupa Birliği",
        "integrate-sdks": "SDK entegrasyonu için yardıma mı ihtiyacınız var?",
        "integrate-sdks-text": "Countly Code Generator sayesinde istediğiniz bir SDK için özelleştirilmiş kod parçasını kolayca oluşturabilir ve bunu mobil ya da web SDK'nızda kullanabilirsiniz.",
        "integrate-sdks-platforms": "Başlamak için bir platform seçiniz",
        "go-to-countries": "Ülkere Git",
        "show": "Göster",
        "show-items": "Göster",
        "try-later": "Bu işlem yapılamadı, daha sonra tekrar deneyin.",
        "never": "Hiç bir zaman",
        "in": {
            "days": "{0} gün içinde",
            "hours": "{0} saat içinde",
            "minutes": "{0} dakika içinde",
            "seconds": "{0} saniye içinde"
        },
        "ago": {
            "just-now": "şimdi",
            "seconds-ago": "{0} saniye önce",
            "half-minute": "yarım dakika önce",
            "less-minute": "bir dakika kadar önce",
            "one-minute": "bir dakika önce",
            "minutes-ago": "{0} dakika önce",
            "one-hour": "1 saat önce",
            "hours-ago": "{0} saat önce",
            "one-day": "1 gün önce",
            "days-ago": "{0} gün önce",
            "one-week": "1 hafta önce"
        },
        "every": {
            "minutes": "her {0} dakikada bir",
            "hours": "her {0} saatte bir",
            "hour": "her saat"
        },
        "estimation": "Total (unique) value for this period is estimated and corrected using the biggest time buckets from available daily, weekly and monthly stats.<br/><br/>Exact total counts are available for this year, month and day periods",
        "action": "İşlem",
        "view": "Görüntüle",
        "back": "Geri",
        "success": "Başarılı",
        "error": "Hata",
        "no-clear": "Hayır, temizleme",
        "yes-discard": "Evet, sil",
        "yes-clear-it": "Evet, temizle",
        "no-dont-change": "Hayır, değiştirme",
        "no-dont-delete": "Hayır, silme",
        "no-dont-continue": "Hayır, devam etme",
        "no-dont-do-that": "Hayır, bunu yapma",
        "last-updated": "Son güncelleme",
        "location": "Konum",
        "enable": "Etkinleştir",
        "running": "Çalışıyor",
        "completed": "Tamamlandı",
        "errored": "Hata",
        "visits": "Ziyaretler",
        "select-columns-to-display": "Görüntülenecek sütunları seçin",
        "enter-value": "Değer girin",
        "optional": "Seçimlik",
        "clear-values": "Değerleri temizle",
        "confirm": "Are you sure?",
        "json-editor": "JSON Editörü",
        "valid-json": "Geçerli JSON kodu",
        "invalid-json": "Geçersiz JSON kodu",
        "format": "Format",
        "saveJSON": "JSON'u kaydet",
        "zoom-in": "Yakınlaş",
        "zoom-out": "Uzaklaş",
        "zoom-reset": "Görünümü sıfırla ({0}%)",
        "group": "GROUP",
        "undo": "Undo",
        "drawer": {
            "next-step": "Next step",
            "previous-step": "Previous step"
        },
        "diff-helper": {
            "changes": "You made {0} changes.",
            "keep": "Do you want to keep them?"
        },
        "discard-changes": "Discard Changes",
        "complete": "Complete",
        "reset": "Reset",
        "remove": "Remove",
        "next": "Next",
        "previous": "Previous"
    },
    "taskmanager": {
        "rerun": "Tekrar çalıştır",
        "view-old": "Önbelleği Göster",
        "confirm-delete-title": "Rapor silinsin mi?",
        "confirm-delete": "Gerçekten {0} isimli raporu silmek istiyor musunuz?",
        "confirm-rerun": "Bu görevi tekrar çalıştırmak istiyor musunuz?",
        "confirm-rerun-title": "Görev tekrar çalıştırılsın?",
        "yes-rerun-task": "Evet, tekrar çalıştır",
        "yes-delete-report": "Evet, raporu sil",
        "rerunning": "Yeniden Çalışıyor",
        "select-origin": "Kaynağı seç",
        "origin": "Kaynak",
        "auto": "Otomatik tazele",
        "manual": "Bir defa",
        "edit": "Düzenle",
        "last-today": "Bugün",
        "last-7days": "Son 7 gün",
        "last-30days": "Son 30 gün",
        "last-60days": "Son 60 gün",
        "manually-table-remind": "Sizin ve ekibiniz tarafından üretilen tek seferlik ya da otomatik tazelenen raporlar",
        "automatically-table-remind": "Raporlar, bir sorgu çalışırken uzun süre geçtiği zaman otomatik olarak oluşturulur",
        "query-added-long": "Querry has been added to long running queries",
        "empty-warning": "There are no long running queries"
    },
    "assistant": {
        "taskmanager": {
            "longTaskTooLong": {
                "title": "Bu işlem uzun zamandır çalışıyor",
                "message": "Bu işlem uzun sürdüğünden <a href='#/manage/tasks'>raporlama yöneticisine</a>aktarıldı. İşlem tamamlandığı zaman bilgi verilecek.",
                "info": "Check its status in Utilities -> Report Manager"
            },
            "longTaskAlreadyRunning": {
                "title": "Benzer bir rapor halen çalışıyor",
                "message": "<a href='#/manage/tasks'>Raporlama yöneticisinde</a> benzer bir işlem halen çalışıyor."
            },
            "completed": {
                "title": "{1} için rapor çekimi tamamlandı",
                "message": "Sonucu görmek için <a href=\"{0}\">buraya</a> tıklayın"
            },
            "errored": {
                "title": "{0} için rapor oluşturulması sırasında bir hata alındı",
                "message": "Bu işlemi <a href='#/manage/tasks'>raporlama yöneticisinde</a> tekrar çalıştırabilirsiniz.",
                "info": "Under Utilities -> Task Manager"
            }
        }
    },
    "placeholder": {
        "old-password": "Eski şifre...",
        "new-password": "Yeni şifre...",
        "again": "Tekrar...",
        "app-name": "Uygulama adını giriniz...",
        "search-columns": "Search Columns",
        "events": {
            "edit": {
                "description": "Enter event description",
                "count": "Count",
                "sum": "Sum",
                "duration": "Duration"
            }
        }
    },
    "application-category": {
        "books": "Kitap",
        "business": "İş Uygulaması",
        "education": "Eğitim",
        "entertainment": "Eğlence",
        "finance": "Finans",
        "games": "Oyun",
        "health-fitness": "Sağlık & Zindelik",
        "lifestyle": "Yaşam Biçimi",
        "medical": "Tıp",
        "music": "Müzik",
        "navigation": "Navigasyon",
        "news": "Haberler",
        "photography": "Fotoğraf",
        "productivity": "Verimlilik",
        "reference": "Referans",
        "social-networking": "Sosyal Ağ",
        "sports": "Spor",
        "travel": "Gezi",
        "utilities": "Yardımcı Uygulamalar",
        "weather": "Hava Durumu"
    },
    "sidebar": {
        "dashboard": "Genel görünüm",
        "analytics": "Analitik",
        "engagement": "Etkileşim",
        "events": "Olaylar",
        "utilities": "Araçlar",
        "management": "Yönetim",
        "settings": "Ayarlar",
        "logout": "Çıkış",
        "api_key": "Api Anahtarı",
        "behavior": "Davranış",
        "category": {
            "understand": "Anla",
            "explore": "Araştır",
            "reach": "Eriş",
            "improve": "Geliştir"
        },
        "long-running-queries": "Long running queries",
        "feedback": "Feedback"
    },
    "dashboard": {
        "apply": "Uygula",
        "avg-time-spent": "ORT. OTURUM SÜRESİ",
        "time-spent": "TOPLAM SÜRE",
        "reqs-received": "ALINAN İSTEKLER",
        "avg-reqs-received": "ORT. ALINAN İSTEKLER",
        "bounce-rate": "HEMEN ÇIKMA ORANI",
        "pages-per-visit": "ZİY. BAŞINA SAYFA",
        "note-title-remaining": "Kalan"
    },
    "users": {
        "title": "KULLANICILAR"
    },
    "user-loyalty": {
        "title": "KULLANICI BAĞLILIĞI",
        "all": "Tüm Kullanıcılar",
        "thirty-days": "Aktif Kullanıcılar (30 gün)",
        "seven-days": "Aktif Kullanıcılar (7 gün)",
        "session-count": "Oturum Sayısı (Tüm Zamanlar)",
        "range": {
            "first-session": "İlk oturum",
            "hours": "saat",
            "day": "gün",
            "days": "gün"
        }
    },
    "sessions": {
        "title": "OTURUMLAR"
    },
    "notes": {
        "add-note": "Not ekle",
        "manage-notes": "Notları yönet",
        "add-note-form-title": "Yeni not ekle",
        "edit-note-form-title": "Not düzenle",
        "note": "Not",
        "note-date-time": "Not tarihi ve saati",
        "note-private": "Özel",
        "note-shared": "Paylaşılmış",
        "note-public": "Açık",
        "note-share-with": "Not paylaşılacak kullanıcılar",
        "note-indicator-color": "Not rengi",
        "note-add-note": "Notu Kaydet",
        "note-all": "Tümü",
        "note-owner": "Sahibi",
        "note-date-and-time": "Tarih & Saat",
        "note-type": "Tür",
        "note-email": "Paylaşılan kişiler",
        "note-back-to-overview": "Ana sayfaya geri dön",
        "note-edit": "Düzenle",
        "note-delete": "Sil",
        "note-delete-note": "Notu Sil",
        "note-delete-title": "Bu not silinsin mi?",
        "note-yes-delete": "Evet, notu sil",
        "private-remind": "Sadece size görünür",
        "shared-remind": "Visible to you and users with provided email addresses",
        "public-remind": "Tüm kullanıcılara görünür",
        "note-textarea-placeholder": "Enter your note text here",
        "note-types": "Not türü"
    },
    "session-frequency": {
        "title": "OTURUM FREKANSI",
        "table": {
            "time-after": "Bir önceki oturumdan sonraki süre"
        }
    },
    "session-duration": {
        "title": "OTURUM SÜRELERİ",
        "table": {
            "duration": "Oturum süresi"
        }
    },
    "countries": {
        "title": "ÜLKELER",
        "table": {
            "country": "Ülke",
            "city": "Şehir"
        },
        "back-to-list": "Ülke Listesine Geri Dön",
        "google-api-key-remind": "Google Maps API key must be setup to view city level data. Click here to setup Google Maps API key."
    },
    "devices": {
        "title": "CİHAZLAR",
        "table": {
            "device": "Cihaz"
        }
    },
    "resolutions": {
        "title": "ÇÖZÜNÜRLÜKLER",
        "table": {
            "resolution": "Çözünürlük",
            "width": "Genişlik",
            "height": "Yükseklik"
        }
    },
    "device_type": {
        "title": "Device Types",
        "table": {
            "device_type": "Device Type"
        }
    },
    "app-versions": {
        "title": "UYGULAMA SÜRÜMLERİ",
        "table": {
            "app-version": "Uygulama Sürümü"
        }
    },
    "carriers": {
        "title": "OPERATÖRLER",
        "table": {
            "carrier": "Operatör"
        }
    },
    "platforms": {
        "title": "PLATFORMLAR",
        "pie-left": "PLATFORMLAR",
        "pie-right": "PLATFORM SÜRÜMLERİ",
        "table": {
            "platform": "Platform",
            "platform-version": "Platform Sürümü",
            "platform-version-for": "Platform Sürümleri:"
        }
    },
    "events": {
        "title": "OLAYLAR",
        "blueprint-title": "OLAYLARI YÖNET",
        "blueprint-general": "Genel",
        "blueprint-events-tab-title": "EVENTS",
        "blueprint-event-group-title": "MANAGE EVENTS GROUPS",
        "blueprint-event-group-new": "New Event Group",
        "blueprint-event-group-show": {
            "all": "All Groups",
            "visible": "Visible Groups",
            "hidden": "Hidden Groups"
        },
        "blueprint-events-show": {
            "all": "All Events",
            "hidden": "Hidden Events",
            "visible": "Visible Events"
        },
        "blueprint-events-properties-tooltip": "Edited properties of this event will be updated on All Events and other plugins.",
        "blueprint-event-groups-include-events-tooltip": "Select at least 2 events to create an Event Group. New Event Groups will automatically  sum all the selected  event properties and report them.",
        "blueprint-event-groups-properties-tooltip": "Edited properties in this Event Group will be updated across All Events and other plugins.",
        "blueprint-event-group-included-events": "INCLUDED EVENTS",
        "blueprint-eventgroups-tab-title": "EVENT GROUPS",
        "blueprint-edit": "Edit",
        "blueprint-drawer-title": "Edit Event",
        "blueprint-drawer-use-description": "Use Description",
        "general": {
            "description": "Özel olayı düzenleyin, görünürlüğünü ayarlayın ya da silin",
            "event": "Olay",
            "event-description": "Olay tanımı",
            "action": {
                "perform-action": "İşlemi belirle",
                "delete": "Sil",
                "show": "Göster",
                "hide": "Gizle"
            },
            "none-chosen": "En az bir olay seçin",
            "update-not-successful": "Olayların güncellenmesi başarısız oldu.",
            "changes-saved": "Değişiklikler kaydedildi",
            "cancel": "İptal",
            "confirm": "Onayla",
            "status": "Durum",
            "show": {
                "title": "Göster",
                "all": "Tümü",
                "hidden": "Gizli",
                "visible": "Görünür"
            },
            "want-delete": "Birden çok olay silmek istiyorsunuz ({0}). Devam etmek istiyor musunuz?",
            "want-delete-this": "{0} isimli olayı silmek istiyorsunuz. Devam etmek istiyor musunuz?",
            "want-delete-this-title": "Olayı sil?",
            "want-delete-title": "Olayları sil?",
            "yes-delete-event": "Evet, olayı sil",
            "yes-delete-events": "Evet, olayları sil",
            "want-to-discard": "Bu olay için değişiklikler yaptınız. Bu sayfadan ayrılmak ve değişiklikleri silmek ister misiniz?",
            "want-to-discard-title": "Değişiklikler silinsin mi?",
            "events-deleted": "Seçili olaylar başarıyla silindi",
            "no-hidden-events": "Hiç gizli olay yok",
            "no-visible-events": "Görüntülenebilir olay yok",
            "error": "Hata"
        },
        "back-to-events": "Tüm olaylara geri dön",
        "no-segmentation": "Bölümleme yok",
        "count": "SAYI",
        "sum": "TOPLAM",
        "dur": "SÜRE",
        "table": {
            "count": "Sayı",
            "sum": "Toplam",
            "avg-sum": "Ort. Toplam",
            "dur": "Süre",
            "avg-dur": "Ort. Süre",
            "segmentation": "Bölümleme"
        },
        "edit": {
            "event-key": "Olay anahtarı",
            "event-key-description": "SDK'dan gönderilen olay anahtarı",
            "event-name": "Olay adı",
            "event-name-description": "Bu olayın anahtar (key) bilgisi için görüntülenecek ifade",
            "event-description": "Açıklama",
            "event-description-description": "A short description of this custom event and when it is triggered",
            "event-visibility": "Event visibility",
            "event-visible": "Olay görüntülenebilir",
            "event-invisible": "Event is invisible",
            "event-visible-description": "Eğer bir olay gizlenmiş ise, sunucu kayıtları tutmaya devam edecek, ancak arayüzde görüntülenmeyecektir.",
            "display-count": "Count için görüntülenecek ifade",
            "display-count-description": "Bu olayın count özelliği için görüntülenecek ifade",
            "display-sum": "Toplam için görüntülenen ifade",
            "display-sum-description": "Bu olayın seçimlik sum özelliği için görüntülenecek ifade",
            "display-duration": "Duration için görüntülenecek ifade",
            "display-duration-description": "Bu olayın seçimlik duration özelliği için görüntülenecek ifade",
            "event-properties": "Event properties",
            "omit-event-segments": "Olay segmentlerini dışarıda tut",
            "omit-event-segments-description": "Choose which segments of this custom event to omit. <b>Omitted segments will not be saved</b> in the future and past data for these segments will be purged immediately after you save these settings.",
            "omit-event-segments-description-drill": "Bu segmentlere ait veriler yine de Drill'de depolanacaktır.",
            "omit-event-segments-to-omit": "Segments to omit",
            "omit-event-select-segments": "Select segments"
        },
        "no-event": "Bu uygulama için henüz hiç olay (event) kaydedilmedi\\!",
        "delete-confirm": "\"{0}\" olayı için bütün veriyi silmek üzeresiniz. Devam etmek istiyor musunuz?",
        "delete-confirm-many": "Bu olaylarla ilgili tüm verileriniz silinecektir. Devam etmek istiyor musunuz?",
        "delete": {
            "multiple-events": "{0} events"
        },
        "overview": {
            "title": "Genel bakış",
            "drawer-title": "Genel görünümü yapılandır",
            "empty": "Genel görünümde herhangi bir öğe bulunmuyor.",
            "configure": "Yapılandır",
            "add-item": "Öğe ekle",
            "added-items": "Eklenen öğeler",
            "choose-event": "Olayı seç",
            "choose-property": "Özelliği seçin",
            "table": {
                "title-event": "Olay",
                "title-property": "Özellik"
            },
            "max-c": "Önizlemeye en çok 12 kutucuk yerleştirebilirsiniz. Yeni kutucuk eklemek için lütfen daha önce eklediklerinizden bazılarını silin.",
            "have-already-one": "You have already one item with the same event and propery in overview.",
            "empty-title": "Olayların genel görünümü boş",
            "empty-text-admin": "Configure events overview to visualise your most important custom events at a glance.",
            "empty-text-user": "Request an admin of this application to configure events overview to visualise most important custom events at a glance.",
            "save-changes": "Değişiklikleri kaydet",
            "unknown": "N/A"
        },
        "all": {
            "empty-title": "This application doesn't have any custom events",
            "empty-text": "Log some custom events inside your application's code using the SDKs and visit this section later"
        },
        "top-events": {
            "title": "Top Events By Count",
            "24hours": "24 Saat",
            "30days": "30 Gün",
            "info-text": "{0} saat önce güncellendi"
        },
        "max-event-key-limit": "Maximum limit of unique event keys ({0}) has been reached. Limit can be <a href=\"/dashboard#/manage/configurations/api\">adjusted</a>.",
        "max-segmentation-limit": "Maximum limit of segmentations ({0}) in current event \"{1}\" has been reached. Limit can be <a href=\"/dashboard#/manage/configurations/api\">adjusted</a>.",
        "max-unique-value-limit": "Maximum limit of unique values ({0}) in current event segmentation \"{1}\" has been reached. Limit can be <a href=\"/dashboard#/manage/configurations/api\">adjusted</a>.",
        "event-group-drawer-create": "Create new Event Group",
        "event-group-name": "Event Group name",
        "group-use-description": "Use description",
        "group-include-events": "Include events",
        "group-select-events": "Select events to include",
        "group-select-events-remind": "Select events",
        "group-visibility": "Event Group Visibility",
        "group-visibility-description": "If an event group is invisible server will continue to record data for it but it will not be displayed in the user interface.",
        "group-visibility-checkbox": "Event Group is visible",
        "group-invisibility-checkbox": "Event Group is invisible",
        "group-properties": "Event Group Properties",
        "event-group-count": "Display name for count",
        "event-group-count-description": "A display name for the count property of this event",
        "event-group-sum": "Display name for sum",
        "event-group-sum-description": "A display name for the sum property of this event",
        "event-group-duration": "Display name for duration",
        "event-group-duration-description": "A display name for the duration property of this event",
        "create-group": "Create Event Group",
        "save-group": "Save Event Group",
        "edit-your-group": "Edit your Event Group"
    },
    "event": {
        "edit": {
            "omitt-warning": "You are about to omit data for some segments of this event. Omitted segments will not be saved in the future and past data for these segments will be purged immediately after you save these settings. Do you want to continue?"
        }
    },
    "export": {
        "export-as": "Farklı kaydet",
        "export-number": "{0} öğe {1} dosyaya aktarılıyor",
        "select": "Aktarılmak istenen dosyayı seçin",
        "export": "Dışa Aktar",
        "columns-to-export": "Columns to export",
        "export-all-columns": "Export all columns",
        "documents": "dokümanlar",
        "export-columns-selected-count": "{0}/{1} selected"
    },
    "management-applications": {
        "title": "UYGULAMALAR",
        "my-new-app": "Yeni uygulamam",
        "clear-data": "Veriyi temizle",
        "clear-reset-data": "Uygulamayı sıfırla",
        "clear-reset-explanation": "Uygulamayı ilk oluşturulduğu haline geri döndürür",
        "clear-all-data": "Tüm verileri sil",
        "clear-all-explanation": "Alınan verileri siler ancak konfigürasyonu silmez",
        "clear-1month-data": "1 aydan eski tüm verileri sil",
        "clear-3month-data": "3 aydan eski tüm verileri sil",
        "clear-6month-data": "6 aydan eski tüm verileri sil",
        "clear-1year-data": "1 yıldan eski tüm verileri sil",
        "clear-2year-data": "2 yıldan eski tüm verileri sil",
        "yes-clear-app": "Evet, uygulama verisini sil",
        "no-clear": "Hayır, silme",
        "delete-an-app": "Uygulamayı sil",
        "yes-delete-app": "Evet, uygulamayı sil",
        "application-name": "Uygulama Adı",
        "application-details": "Detayları göster",
        "app-details": "Uygulama Detayları",
        "application-no-details": "Uygulama detayları alınamadı",
        "type": "Uygulama Türü",
        "category": "Kategori",
        "app-id": "App ID",
        "app-key": "Uygulama Anahtarı",
        "time-zone": "Zaman Dilimi",
        "icon": "Simge",
        "add-application": "Uygulama ekle",
        "clear-confirm-all": "Uygulamanız için şimdiye kadar toplanan tüm verileri silmek üzeresiniz. Devam etmek istiyor musunuz?",
        "clear-confirm-period": "Belirli bir zaman içinde toplanan tüm verileri silmek üzeresiniz. Devam etmek istiyor musunuz?",
        "clear-confirm-reset": "Uygulamanızı ilk açıldığı haline geri döndürmek üzeresiniz. Devam etmek istiyor musunuz?",
        "clear-admin": "Sadece uygulamanın yöneticisi verileri silebilir.",
        "clear-success": "Uygulama verisi başarıyla silindi.",
        "reset-success": "Uygulama başarıyla sıfırlandı ve temizlendi.",
        "delete-confirm": "Uygulamanızı tamamen silmek üzeresiniz. Devam etmek istiyor musunuz?",
        "delete-admin": "Sadece uygulamanın yöneticisi bu uygulamayı silebilir.",
        "app-locked": "Uygulama kilitli",
        "icon-error": "Sadece JPG, PNG ve GIF formatları destekleniyor.",
        "no-app-warning": "Veri toplamaya başlamak için hesabınıza bir uygulama eklemelisiniz.",
        "app-key-change-warning-title": "Uygulama anahtarının değiştirilmesi",
        "app-key-change-warning": "Changing the app key will cause all users from this point on to be recorded as new users even if they used your application before. <br/><br/>This action is only recommended if you are migrating an application from another server or changing the app key of a new application.",
        "app-key-change-warning-confirm": "Evet, uygulama anahtarını değiştir",
        "app-key-change-warning-EE": "Uygulamanın anahtarını değiştirmek bu noktadan sonra tüm kullanıcıların yeni bir kullanıcı olarak tanımlanmasına neden olacaktır. <br/><br/>Bu işlem sadece uygulamanın bir sunucudan diğerine aktarılması, ya da yeni bir uygulamanın app key'ini değiştirmek için kullanılmalıdır. <br/><br/>Eğer düşünceniz bu uygulamanın aldığı verileri durdurmak ise bu işlem Filtering Rules eklentisi ile yapılmalıdır.",
        "first-app-message2": "Harika! Şimdi SDK'ları uygulamanıza koyup istatistikleri anında görmeye başlayabilirsiniz. Yukarıdan App Key'inizi almayı unutmayın.",
        "types": {
            "mobile": "Mobil"
        },
        "checksum-salt": "Checksum salt",
        "app-creator": "Uygulamayı oluşturan",
        "app-created-at": "Oluşturulma tarihi",
        "app-edited-at": "Son düzenleme tarihi",
        "app-last-data": "Son veri kaydedilme tarihi",
        "app-users": "Uygulamanın kullanıcıları",
        "global_admins": "Genel yöneticileri",
        "admins": "Yöneticileri",
        "users": "Kullanıcıları",
        "plugins": "APP SETTINGS",
        "create-first-app-title": "İlk uygulamamızı ekleyelim.",
        "create-first-app-description": "Bu uygulamayı ekledikten sonra veri toplamaya ve analiz etmeye hazırsınız.",
        "contact-an-admin": "Lütfen sistem yöneticinize başvurun",
        "dont-access": "Herhangi bir uygulamaya erişiminiz yok.",
        "plugins-description": "Settings in this section will override global settings for the application",
        "application-lock-tooltip": "Uygulamayı kilitlemek yanlışlıkla veri silinmesi ve demo veri atılmasını engeller"
    },
    "management-users": {
        "create-new-user": "Yeni bir kullanıcı yarat",
        "full-name": "İsim",
        "username": "Kullanıcı ismi",
        "password": "Şifre",
        "generate-password": "Şifre oluştur",
        "change-password": "Şifre değiştir",
        "role": "Rol",
        "email": "Eposta",
        "global-admin": "Genel Yönetici",
        "lock-account": "Hesabı Kilitle",
        "time-banned": "Hesapta süre sınırlı giriş yasağı var",
        "remove-ban": "Giriş yasağını kaldır",
        "remove-ban-notify-title": "Giriş yasağı kaldırıldı.",
        "remove-ban-notify-message": "Kullanıcının giriş yasağı kaldırıldı.",
        "admin": "Yönetici",
        "admin-of": "Yöneticisi",
        "user": "Kullanıcı",
        "user-of": "Kulanıcısı",
        "no-role": "Rol yok",
        "create-user": "Kullanıcı Oluştur",
        "delete-user": "Kullanıcı Sil",
        "edit": "Düzenlemek için tıklayın",
        "close": "Kapatmak için tıklayın",
        "password-change-confirm": "You have changed {0}\\''s password. Do you want a notification email to be sent?",
        "delete-confirm": "You are about to delete {0}\\''s account. Do you want to continue?",
        "delete-confirm-title": "Bu kullanıcıyı sil?",
        "yes-delete-user": "Evet, kullanıcıyı sil",
        "add-user": "Kullanıcı ekle",
        "revoke-access": "Erişimi Geri Al",
        "admin-user-alert": "Bu kişiyi, yönetici ya da kullanıcı olarak en az bir uygulamaya dahil etmelisiniz.",
        "revoke-confirm": "Bu kullanıcının uygulamalarınıza erişimini silmek üzeresiniz. Devam etmek istiyor musunuz?",
        "email-tip": "Bu eposta için bir hesap olmasa da kullanıcı uyarılacaktır...",
        "last_login": "Son Giriş",
        "created": "Oluşturulma"
    },
    "user-settings": {
        "username": "Kullanıcı adı",
        "change-password": "Şifre değiştir",
        "old-password": "Eski şifre...",
        "new-password": "Yeni şifre...",
        "password-again": "Tekrar...",
        "alert": "Bir şeyler yanlış gitti...",
        "success": "Ayarlar başarıyla kaydedildi\\!",
        "api-key": "API Anahtarı",
        "password-match": "Şifreler uyuşmuyor",
        "old-password-match": "Değiştirmek için önceki parolanızı girin",
        "old-password-not-match": "Önceki parola hatalı girildi",
        "password-not-old": "Yeni parola eskisi ile aynı olmamalıdır",
        "force-password-reset": "Parolanızı değiştirme zamanı geldi",
        "please-correct-input": "Lütfen formu göndermeden önce hataları düzeltin",
        "api-key-length": "API anahtarı tam 32 karakter uzunluğunda olmalıdır",
        "api-key-restrict": "API key should contain digits and alphabetical characters",
        "regenerate-api-key": "API anahtarını yeniden oluştur",
        "delete-account-title": "Hesap silinsin mi?",
        "delete-account-confirm": "Gerçekten bu hesabı silmek istiyor musunuz? Bu işlemin geri dönüşü yoktur.",
        "password-mandatory": "Parola girişi şarttır!",
        "global Bu hesap son global admin yöneticisi hesabıdır": {
            " Bu nedenle silinemez": {
                "": ""
            }
        },
        "password not valid": "Given password is not valid",
        "profile-picture": "Profil Fotoğrafı"
    },
    "user-settigs": {
        "delete-account": "Hesabı sil"
    },
    "report-manager": {
        "name": "İsim",
        "desc": "Açıklama",
        "name-and-desc": "İsim ve Açıklama",
        "data": "Veri",
        "period": "Periyod",
        "visibility": "Görünürlük"
    },
    "report-maanger": {
        "manually-created": "Elle Oluşturulan",
        "automatically-created": "Otomatik oluşturulan",
        "manually-created-title": "Elle Oluşturulan Raporlar",
        "automatically-created-title": "Otomatik Oluşturulan Raporlar"
    },
    "app-users": {
        "export-userdata": "Kullanıcı verisini dışarı aktar",
        "download-export": "Kullanıcının dışarı aktarılan verisini indir",
        "delete-export": "Dışarı aktarılan veriyi sil",
        "delete-userdata": "Kullanıcı verisini tamamen sil",
        "delete-userdata-confirm": "Bu kullanıcıya ilişkin tüm veriyi gerçekten silmek istiyor musunuz?",
        "export-started": "Dışarı aktarma işlemi başlatıldı.",
        "export-finished": "Kullanıcı verisi dışarı aktarıldı. Bunu şimdi indirebilirsiniz.",
        "export-finished-click": "İndirmek için tıklayın.",
        "export-failed": "Dışarı alma işleminde bir hata oluştu. Lütfen loglara göz atın ve servis sağlayıcınız ile iletişime geçin.",
        "export-deleted": "Dışarı aktarılan veri silindi",
        "userdata-deleted": "Kullanıcı verisi silindi",
        "yes-purge-data": "Evet, veriyi sil",
        "no-dont-purge": "Hayır, silme",
        "purge-confirm-title": "Kullanıcının tüm verisi silinsin mi?"
    },
    "downloading-view": {
        "download-title": "İndirme çok yakında başlayacak",
        "if-not-start": "Eğer indirme otomatik başlamazsa buraya tıklayın",
        "download-not-available-title": "İndirme başlatılamadı.",
        "download-not-available-text": "Bu linkle ilişkili hiç dışarı aktarma yok. Bu dosya daha önce silinmiş olabilir"
    },
    "token_manager": {
        "page-title": "Anahtar Yöneticisi",
        "create-token": "Anahtar oluştur",
        "table": {
            "id": "Anahtar ID",
            "ends": "Geçerlilik süresi",
            "multi": "Çoklu kullanım",
            "owner": "Anahtar sahibi",
            "app": "Uygulama",
            "status": "Durum",
            "endpoint": "Uç noktalar",
            "endpoint-name": "Uç nokta adı",
            "purpose": "Açıklama",
            "purpose-desc": "Some information to help user identify created token.",
            "endpoint-desc": "You can limit token to a single or multiple endpoints.<br/>Given endpoints are interpreted as regular expressions.",
            "multi-desc": "Token can be used multiple times",
            "apps-title": "Anahtar kullanımı",
            "apps-limit": "Allow token to be used only in some apps",
            "apps-allow": "Bu anahtarın tüm uygulamalarda kullanılmasını sağla",
            "limit-limit": "Sınırlı süre - anahtar, belirlediğiz süre sonuna kadar kullanılabilir",
            "limit-allow": "Sınırsız süre - anahtar, silinene kadar kullanılabilir",
            "limit-title": "Anahtar süresi",
            "enter-number": "Sayıyı girin",
            "not-expire": "No expiry",
            "all-apps": "Tüm uygulamalar",
            "delete-token": "Delete token",
            "status-expired": "expired",
            "status-active": "active"
        },
        "limit": {
            "h": "saat",
            "d": "gün",
            "m": "ay"
        },
        "delete-token-confirm": "Gerçekten bu anahtarı silmek istiyor musunuz?",
        "delete-token-confirm-title": "Anahtar silinsin mi?",
        "yes-delete-token": "Evet, anahtarı sil",
        "delete-error": "Anahtar silinmesi işlemi başarısız",
        "select-apps-error": "You have to chose apps or  set option to \"Allow token to be used in all apps\"",
        "select-expire-error": "You have to choose after how long time token expires or set option to \"Token can be used till it is deleted\"",
        "copy-token": "Kopyalamak için tıklayın",
        "token-coppied": "Anahtar kopyalandı",
        "query-param": "Query parameters",
        "query-param-value": "Value",
        "query-param-desc": "Limit by some parameter values(for example method=get_events) Value is used as regex when validating.",
        "add-new-endpoint": "Add new endpoint",
        "add-param": "Parametre ekle",
        "parameter": "Parametre",
        "select-apps": "Uygulamaları seç",
        "select-time-unit": "Zaman birimini seç",
        "token-expiration-time": "Token expiration time",
        "LoginAuthToken-description": "This token is created when creating dashboard screenshots. <br/>If you are not currently rendering dashboard images, you can delete this token.",
        "LoggedInAuth-description": "This token is used for keeping users session.<br/> Deleting it will log out user currently using it to keep session."
    },
    "version_history": {
        "page-title": "Countly sürüm geçmişi",
        "current-version": "Geçerli sürüm",
        "package-version": "Package version",
        "version": "Sürüm",
        "upgraded": "Güncelleme / kurulum"
    },
    "internal-events": {
        "[CLY]_session": "Oturum"
    },
    "jobs": {
        "back-to-jobs-list": "Back to jobs list",
        "job-name": "Name",
        "job-schedule": "Schedule",
        "job-next-run": "Next Run",
        "job-last-run": "Last Run",
        "job-status": "Status",
        "job-total-scheduled": "Total",
        "job-data": "Data",
        "run-duration": "Duration"
    },
    "emails": {
        "greeting": {
            "header": "myCountly'ye hoşgeldin {0}!"
        }
    }
}
